import React,{ useState, useEffect } from 'react';
import Spinner from 'react-bootstrap/Spinner';
import { formatCurrency } from '../services/formatservice';

export const Top3 = (props) => {
  const [data, setdata] = useState([]);
  const [loaded, setloaded] = useState(false);

  useEffect(() => {
    if(props.data.length !== 0) {
      setdata(props.data);
      setloaded(true);
    }
  }, [props]);

  function info() {
    if(data.statistics.highscore) {

    return(
        <>
          <div className='toppadding'>
            <h2>Topplista</h2>
          </div>
          <div className='break'></div>
          <ul className='bottompadding'>
            {
            data.statistics.highscore.map(high => (
              <li key={"top3-" + high.hipnr}>
                <span className='inline-block' style={{width: "600px"}}>#<b>{high.hipnr} {high.horsename}</b></span> 
                <span className='inline-block text-end' style={{width: "400px"}}>{formatCurrency(high.price)}</span>
              </li>
            ))}
          </ul>
        </>
      )
    }
    return(
      <></>
    )
  }

  let content = loaded
    ? info()
    : <Spinner/>;

    return(
      <>
        {content}
      </>
    );
}